import styled from 'styled-components'
import AppLinkMobileCtrl from 'Components/AppLinkMobileCtrl'
import ImagePlaceholder from 'Components/ImagePlaceholder'
import {
  TEXT_GREY, LINK_COLOR, CLICKABLE_COLOR, SELECTED_ITEM_BG_COLOR,
} from '@CSSVars/colors'
import { BREAK_POINT_LG } from '@CSSVars/variables'

export const _ProjectInfoContainer = styled.div`
  display: flex;
  background-color: #F8F8F8;
  border-radius: 10px;
  width: auto;
  margin-bottom: 24px;

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    flex-direction: column;
    margin-bottom: 0;
  }
`

export const _LeftContainer = styled.div`
  border-radius: 10px 0px 0px 10px;
  overflow: hidden;

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    width: 100%;
    border-radius: 10px 10px 0px 0px;
  }
  `

export const _RightContainer = styled.div`
  padding: 32px 48px;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    padding: 16px;

    h2 {
      text-align: center;
    }
  }

  `

export const _DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  
  span {
    font-weight: 600;
  }

  .address {
    padding-top: 4px;
    color: ${TEXT_GREY};
  }

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    align-items: center;
  }
`

export const _BuildingLink = styled(AppLinkMobileCtrl)`
  font-size: 28px;
  line-height: 40px;
  text-decoration: underline;
  pointer-events: visible;
  color: ${CLICKABLE_COLOR}!important;
  font-weight: 600 !important;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (hover: hover){
    &:hover{
      color:${LINK_COLOR} !important;
    }
  }
  &:active{
    color: ${SELECTED_ITEM_BG_COLOR} !important;
  }

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    font-weight: 500;
    white-space: wrap;
  }
  `

export const _BuildingImage = styled(ImagePlaceholder)`
  width: 300px;
  height: 210px;
  img {
    min-width: 100%;
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    width: 100%;
    height: 135px;
  }
`
